export default __webpack_public_path__ + "f9c524e158b97ce7db977cd57dcf5523.wav";